import { ToDo } from '@/components/todo-page';
import { Helmet as Head } from 'react-helmet';

const ToDoPage = () => {
  return (
    <>
      <Head>
        <title>To Do List</title>
      </Head>
      <ToDo />
    </>
  );
};

export default ToDoPage;
